import React from 'react';
import { string, object, number } from 'yup';
import { useTranslation } from 'react-i18next';

import FormResource from './FormResource.jsx';
import FormGroup from '~/commons/components/FormGroup.jsx';
import FieldFileSlider from '~/commons/components/FieldFileSlider.jsx';

const schema = object({
  title: object().shape({
    zhhk: string().required(),
  }),
  score: number().required(),
});

const defaults = {
  title: {
    en: '',
    zhhk: '',
  },
  score: '',
  description: {
    en: '',
    zhhk: '',
  },
  avatars: [],
  coverImg: '',
};

const FormLevel = ({
  level,
  onSubmit,
}) => {
  const { t } = useTranslation();

  return (
  <FormResource
    {...{
      defaults,
      schema,
      stored: level,
      api: '/api/quiz/levels',
      onSubmit,
    }}
  >
    <div className="row">
      <div className="col">
        <FormGroup name="title.zhhk" label={t('Title')} />
        <FormGroup name="score" label={t('Score')} type="number" />
        <FormGroup name="description.zhhk" label={t('Description')} />
      </div>
      <div className="col-4">
        <FormGroup
          name="coverImg"
          as="coverImg"
          label={t('Thumbnail')}
          api="/api/site/view-slots/files"
          className="contain"
        />
      </div>
    </div>
    <FormGroup
      name="avatars"
      as="slider"
      label={t('Avatars')}
      api="/api/quiz/levels/files"
      gridClassName="col-3 my-3"
      slideClassName="file-slide-contain square"
    />
  </FormResource>
  );
};

export default FormLevel;
